// extracted by mini-css-extract-plugin
export var assigneeBadge = "_bh-0";
export var assigneeDetails = "_bh-1";
export var assigneeInfo = "_bh-2";
export var dropdownContainer = "_bh-4";
export var dropdownImage = "_bh-5";
export var editAssigneeInfo = "_bh-3";
export var editAssigneeModalContainer = "_bh-6";
export var hidden = "_bh-8";
export var input = "_bh-7";